import Lootie from '@/assets/lootie/404.json';
import { clearBearerToken } from '@/common/axios';
import { ROUTE_HOME, ROUTE_LOGIN } from '@/common/constants';
import Lottie from 'lottie-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft } from 'lucide-react';

export const ScreenError404: FC<{
  title: string;
  withoutNavigate?: boolean;
}> = ({ title = 'you.are.not.admin', withoutNavigate = true }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const logout = () => {
    clearBearerToken();
    navigate(ROUTE_LOGIN);
  };

  return (
    <div className="h-screen w-full flex items-center justify-center">
      <div className="absolute top-10 flex flex-col items-center justify-center space-y-6">
        <p className=" text-5xl font-bold ">{t(title)}</p>
        {!withoutNavigate ? (
          <Button onClick={() => logout()}>{t('logout')}</Button>
        ) : (
          <Button onClick={() => navigate('/')}>
            <ArrowLeft /> {t('back')}
          </Button>
        )}
      </div>

      <Lottie
        animationData={Lootie}
        loop
        autoplay
        className="w-[700px] h-fit"
      />
    </div>
  );
};
